import { FeedbackDto } from 'gleblu-socket-api';

import Feedback from '../interfaces/Feedback';

export default function toDto(feedback: Feedback): FeedbackDto {
  const { uuid, message } = feedback;
  return { uuid, message };
}
